/* eslint-disable */
import React, { useState } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiStar } from 'react-icons/fi'
import {
  ILicense,
  ILicenseServices,
  IntegrationStatus as IntegrationStatusLicense,
  LicenseType,
} from '../../../../../models/License'
import Badge from '../../../../../components/Template/Badge'
import { Integration, Label, MenuElement, MenuList, } from '../../../../../components/Template/Sidebar'
import SpinningIcon from '../../../../../components/Template/SpinningIcon'
import { theme } from '../../../../../theme'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import countIntegrations from './countIntegrations'
import { useSelector } from 'react-redux'
import { getAirbnbConnectedListings, getAirbnbStatus, getAirbnbSync, } from '../../../../../reducers/airbnb/selectors'
import { IntegrationStatus } from '../../../../../reducers/airbnb'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  getUserId,
  getUserLanguage,
  getUserPriceGroup,
  isUserNewPackage,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import {
  getActiveLicense,
  isAllInOneLicenseValid,
  isNewPremiumLicenseValid,
} from '../../../../../reducers/userAccount/selectors/license'
import { isInPlanScope, isInPlanScopeRedirect, PlansScope, useLicensePlansScope, } from '../index'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import { getBoxBuyStatus } from '../../../../../reducers/boxbuy/selectors'

function Integrations({
  isSidebarOpen,
  className,
  integrations,
  isLoading,
  licenses,
  size = 1,
}: IIntegrationsProps & WithTranslation & IWithSize) {
  const [isOpen, toggleOpen] = React.useState(false)
  const isNewPlansPriceGroup = useSelector(isUserNewPackage)
  const isValidAllInOneLicense = useSelector(isAllInOneLicenseValid)
  const isValidNewPlans = useSelector(isNewPremiumLicenseValid) || (isValidAllInOneLicense && !isNewPlansPriceGroup)
  const currentPlan = useSelector(getActiveLicense)
  const mediaQueryTheme = useTheme()
  const isMobile = useMediaQuery(mediaQueryTheme.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }
  const count = !isLoading ? countIntegrations(integrations, licenses) : 0
  const userLang = useSelector(getUserLanguage)
  const status = useSelector(getAirbnbStatus)
  const boxBuyStatus = useSelector(getBoxBuyStatus)
  const sync = useSelector(getAirbnbSync)
  const airbnbListings = useSelector(getAirbnbConnectedListings)
  const userId = useSelector(getUserId)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const planScope = useLicensePlansScope()
  const getBoxBuyIconStatus =() => {
    if (!!boxBuyStatus) {
      return IntegrationStatusLicense.Active
    } else {
      return IntegrationStatusLicense.NotConfigured
    }
  }


  const getAirbnbIconStatus = () => {
    if (!isValidNewPlans && airbnbListings.length === 0) {
      return IntegrationStatusLicense.NotPurchased
    }

    if (
      isValidNewPlans &&
      status === IntegrationStatus.Integrated &&
      airbnbListings.length === 0
    ) {
      return IntegrationStatusLicense.Inactive
    }
    if (isValidAllInOneLicense && !isNewPlansPriceGroup && airbnbListings.length > 0) {
      return IntegrationStatusLicense.Active
    }

    if (isValidNewPlans && airbnbListings.length > 0) {
      return IntegrationStatusLicense.Active
    }

    if (isValidNewPlans && status === IntegrationStatus.NotIntegrated) {
      return IntegrationStatusLicense.NotConfigured
    }
    if (!isValidNewPlans && airbnbListings.length > 0) {
      return IntegrationStatusLicense.NotPurchased
    }
  }

  const getIconBookingStatus = () => {
    if (
      (currentPlan?.licenseType === LicenseType.LICENSE_PREMIUM_LITE ||
        currentPlan?.licenseType === LicenseType.LICENSE_PREMIUM_PLUS) &&
      +userPriceGroup !== 3
    ) {
      return {...integrations.booking, status: IntegrationStatusLicense.NotConfigured}
    } else {
      return integrations.booking
    }
  }

  const getIconIcalendarStatus = () => {
    if (
      (currentPlan?.licenseType === LicenseType.LICENSE_PREMIUM_LITE ||
        currentPlan?.licenseType === LicenseType.LICENSE_PREMIUM_PLUS) &&
      +userPriceGroup !== 3
    ) {
      return {...integrations.iCalendar, status: IntegrationStatusLicense.NotConfigured}
    } else {
      return integrations.iCalendar
    }
  }

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Booking.com Menu Opened', 1)
    Mixpanel.track('Main Menu Booking.com Item Used', {})
  }
  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Airbnb Menu Opened', 1)
    Mixpanel.track('Main Menu Airbnb Item Used', {})
  }
  const trackClick3 = () => {
    Mixpanel.people.increment(userId, 'iCalendar Menu Opened', 1)
    Mixpanel.track('Main Menu iCalendar Item Used', {})
  }
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      handlePopoverOpen(event)
    }
  }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          className={`${className}-button-expand`}
          onClick={toggleIsOpen}
          open={isOpen}
          nested={true}
        >
          <b>
            <FiStar size={16 * size} />
          </b>
          <Label size={size} primary={true} className={`${className}-label`}>
            <Trans i18nKey={'BED_3604_sales_channels'} />
          </Label>

          {isSidebarOpen && isLoading && <SpinningIcon />}

          {isSidebarOpen && !isLoading && (
            <React.Fragment>
              <Badge
                size={size}
                className={`${className}-badge`}
                primary={!!count}
              >
                {count}
              </Badge>
              <b style={{ marginLeft: `${5 * size}px` }}>
                {isOpen ? (
                  <FiChevronDown size={14 * size} />
                ) : (
                  <FiChevronRight size={14 * size} />
                )}
              </b>
            </React.Fragment>
          )}
        </MenuElement>

        {isSidebarOpen && !isLoading && (
          <MenuList
            size={size}
            nested={true}
            noPadding={true}
            style={{ maxHeight: 'var(--full)' }}
          >
            <Integration
              onClick={e => {
                trackClick2()
                handleLinkClick(e, PlansScope.Airbnb)
              }}
              size={size}
              className={className}
              data={{
                status: isInPlanScope(
                  planScope,
                  PlansScope.Airbnb,
                  userPriceGroup,
                )
                  ? 4
                  : getAirbnbIconStatus(),
              }}
              label={'Airbnb'}
              color={theme.colors.palette.airbnb}
              link={isInPlanScopeRedirect(
                planScope,
                PlansScope.Airbnb,
                '/integration/airbnb',
                userPriceGroup,
              )}
            />
            <Integration
              onClick={e => {
                trackClick()
                handleLinkClick(e, PlansScope.BookingCom)
              }}
              size={size}
              className={className}
              data={
                isInPlanScope(planScope, PlansScope.BookingCom, userPriceGroup)
                  ? {
                      ...integrations.booking,
                      status: 4,
                    }
                  : getIconBookingStatus()
              }
              label={'Booking'}
              color={theme.colors.palette.booking}
              link={isInPlanScopeRedirect(
                planScope,
                PlansScope.BookingCom,
                '/integration/booking-connect',
                userPriceGroup,
              )}
            />
            <Integration
              onClick={e => {
                trackClick3()
                handleLinkClick(e, PlansScope.ICalendar)
              }}
              size={size}
              className={className}
              data={
                isInPlanScope(planScope, PlansScope.ICalendar, userPriceGroup)
                  ? {
                      ...integrations.iCalendar,
                      status: 4,
                    }
                  : getIconIcalendarStatus()
              }
              label={'iCalendar'}
              color={theme.colors.palette.icalendar}
              link={isInPlanScopeRedirect(
                planScope,
                PlansScope.ICalendar,
                '/integration/icalendar',
                userPriceGroup,
              )}
            />
            {(userLang === 'pl_PL' || userLang === 'pl')  && <Integration
              onClick={() => {
                trackClick2()
              }}
              size={size}
              className={className}
              data={{
                status: getBoxBuyIconStatus()
              }}
              label={'BoxBuy'}
              color={theme.colors.palette.boxbuy}
              link={isInPlanScopeRedirect(
                planScope,
                PlansScope.Airbnb,
                '/integration/boxbuy',
                userPriceGroup,
              )}
            />}
          </MenuList>
        )}
      </MenuElement>
      <PopoveredIcon2
        withIcon={false}
        anchorEl={popoverAnchor}
        // onOpen={handlePopoverOpen}
        onClose={handlePopoverClose}
      />
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default Integrations

export interface IIntegrationsProps {
  isSidebarOpen?: boolean
  className: string
  licenses: ILicense[]
  integrations: ILicenseServices
  isLoading: boolean
}
